import {
  AttachmentPreview, Card, Flexbox,
} from '@/components'
import React from 'react'
import PropTypes from 'prop-types'

const getQuestionnaire = (clinicalCare) => (
  clinicalCare?.questionnaire
  || clinicalCare?.classificationQuestionnaire
  || clinicalCare?.classification?.questionnaire
)

const getQuestionAnswer = (question) => {
  const answer = question?.answer ?? question?.response ?? question?.value
  if (Array.isArray(answer)) return answer.join(', ')
  if (answer && typeof answer === 'object') return answer.description ?? answer.value ?? answer.answer ?? '-'
  if (typeof answer === 'boolean') return answer ? 'Sim' : 'Não'
  return answer === undefined || answer === null || answer === '' ? '-' : answer
}

const getQuestionAttachments = (question) => (
  question?.attachments || question?.answer?.attachments || []
)

function QuestionnaireAnswers({ clinicalCare }) {
  const questionnaire = getQuestionnaire(clinicalCare)
  const questions = (questionnaire?.questions ?? [])
    .slice()
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))

  if (!questions.length) return null

  return (
    <Card.Base>
      <Card.Header>
        <Flexbox.Columns className="align-center">
          <Flexbox.Column>
            <div className="h5">Questionário da classificação</div>
          </Flexbox.Column>
          <Flexbox.Column className="col-auto">
            <i className="fas fa-clipboard-list" />
          </Flexbox.Column>
        </Flexbox.Columns>
      </Card.Header>
      <Card.Body>
        {
          questions.map((question, index) => {
            const attachments = getQuestionAttachments(question)
            return (
              <div key={question?.id || index} className="mb-2">
                <div className="text-bold">
                  {index + 1}. {question?.description}
                </div>
                <div className="pre text-small my-1">
                  {getQuestionAnswer(question)}
                </div>
                {Boolean(attachments.length) && (
                  <Flexbox.Columns className="mt-1">
                    {
                      attachments.map((url) => (
                        <Flexbox.Column className="col-auto" key={url}>
                          <AttachmentPreview size={80} src={url} />
                        </Flexbox.Column>
                      ))
                    }
                  </Flexbox.Columns>
                )}
                {index < questions.length - 1 && <div className="divider" />}
              </div>
            )
          })
        }
      </Card.Body>
    </Card.Base>
  )
}

QuestionnaireAnswers.propTypes = {
  clinicalCare: PropTypes.objectOf(Object).isRequired,
}

export default QuestionnaireAnswers
